  
  $('.testimonial-row-1').slick({
  infinite: true,
  slidesToShow: 5,
  prevArrow: '<img class="prod_slider_prev" src="https://cdn.shopify.com/s/files/1/0958/6956/7287/files/icon_left_slider.svg?v=1760482322" alt="img">',
  nextArrow: '<img class="prod_slider_next" src="https://cdn.shopify.com/s/files/1/0958/6956/7287/files/icon_right_slider.svg?v=1760482322 alt="img">',
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow:4
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3
      }
    },
      {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 426,
           settings: {
            slidesToShow: 1
          }
        },
         {
          breakpoint: 375,
           settings: {
            slidesToShow: 1
          }
        }
    ]
});

  $('.review_slider').slick({
    dots: false,
    slidesToShow: 2,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: `<button type="button" class="slick-prev">
                    <img src="https://cdn.shopify.com/s/files/1/0958/6956/7287/files/review-left_f31b1a6d-6c96-460a-9f95-26ac8a7eb435.svg?v=1770496446">
                </button>`,
    nextArrow: `<button type="button" class="slick-next">
                    <img src="https://cdn.shopify.com/s/files/1/0958/6956/7287/files/review-right_f0ac5550-b50c-4f49-aad0-cc9f95fdb548.svg?v=1770496446">
                </button>`,
    responsive: [
      {
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
          arrows: false,
          dots: true
        }
      }
    ]
  });


  $('.product_slider').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,responsive: [
      {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        },
      {
          breakpoint: 426,
           settings: {
            slidesToShow: 1
          }
        },
         {
          breakpoint: 375,
           settings: {
            slidesToShow: 1
          }
        }
    ]
  });

 
  $('.testimonial-row-2').slick({
  infinite: true,
  slidesToShow: 4,
  prevArrow: '<img class="prod_slider_prev" src="https://cdn.shopify.com/s/files/1/0958/6956/7287/files/icon_left_white.svg?v=1760482322" alt="img">',
  nextArrow: '<img class="prod_slider_next" src="https://cdn.shopify.com/s/files/1/0958/6956/7287/files/icon_right_white.svg?v=1760482322" alt="img">',
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow:3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
      {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.2
          }
        },
      {
          breakpoint: 426,
           settings: {
            slidesToShow: 1.2,
              centerMode: true,
  centerPadding: '40px',
          }
        },
         {
          breakpoint: 375,
           settings: {
            slidesToShow: 1.1,
              centerMode: true,
  centerPadding: '20px',
          }
        }
    ]
});

    
  $('.testimonial-row-3').slick({
  infinite: true,
  slidesToShow: 4,
  prevArrow: '<img class="prod_slider_prev" src="https://cdn.shopify.com/s/files/1/0958/6956/7287/files/icon_left_slider.svg?v=1760482322" alt="img">',
  nextArrow: '<img class="prod_slider_next" src="https://cdn.shopify.com/s/files/1/0958/6956/7287/files/icon_right_slider.svg?v=1760482322" alt="img">',
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow:3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
      {
          breakpoint: 576,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 426,
           settings: {
            slidesToShow: 1,
          }
        }
    ]
});
  
  // news
$('#news_tcker_id').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	autoplay: true,
	autoplaySpeed: 0,
	speed: 3000,
	pauseOnHover: false,
	cssEase: 'linear',
  variableWidth: true,
  });

 
 
 // header active
    $(document).ready(function(){
        $('.nav-center li a').click(function(){
            //remove all pre-existing active classes
            $('.nav-center li a.active').removeClass('active');
            $(this).addClass('active');
        });
    });



//   header script

function closeDiv() {
	document.getElementById("Dropdown2").style.display = "none";
}

function openNav() {
	document.getElementById("mySidebar").style.width = "425px";
	document.getElementById("mySidebar").style.transition = "0.5s";
	document.getElementById("mySidebar").style.boxShadow = "0 0 0 10000px rgba(0,0,0,.75) ";
	document.getElementById("SidebarUl").style.opacity = "1";
	document.getElementById("SidebarUl").style.transition = "0.2s";
}
var abc;

function closeNav() {
	document.getElementById("mySidebar").style.width = "0";
	document.getElementById("mySidebar").style.boxShadow = "none ";
	document.getElementById("SidebarUl").style.opacity = "0 ";
	document.getElementById("SidebarUl").style.transition = "0.1s";
	var sd = document.getElementsByClassName("MobileNav2");
	for (let i = 0; i < sd.length; i++) {
		sd[i].style.width = "0";
		sd[i].style.left = "-100px";
	}

}

function OpenLi(clickedID) {
	var elementid = document.getElementById(clickedID);
	let str = clickedID;
	str = str.substring(1);
	// alert(str);
	// if ("NavItem1" == clickedID) {
	var Imgid = document.getElementById(str);
	Imgid.style.width = "425px";
	Imgid.style.left = "0";
	abc = Imgid;
	// }
}

function backtoNav() {
	var ccc = abc;
	ccc.style.width = "0";
	ccc.style.left = "-100px";

}

// top x
$(document).ready(function(){
	$(".cross-top-bar").click(function(){
	  $(".top-h-breadcrumb").hide();
	});
  });



//  ============  product page slider =============

$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    // prevArrow:'<i class="far fa-chevron-left prod_slider_prev"></i>',
    // nextArrow:'<i class="far fa-chevron-right prod_slider_next"></i>',
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    prevArrow:'<i class="far fa-chevron-left prod_slider_prev"></i>',
    nextArrow:'<i class="far fa-chevron-right prod_slider_next"></i>',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,

responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 5,
      }
    },
   
    {
      breakpoint: 576,
      settings: {
      slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
      slidesToShow: 3,
      }
    }
    ]
});

// radio button
     // Add active class on selection
    const options = document.querySelectorAll(".purchase-option");
    options.forEach(option => {
      option.addEventListener("click", () => {
        options.forEach(o => o.classList.remove("active"));
        option.classList.add("active");
        option.querySelector("input").checked = true;
      });
    });

    // Set default active
    document.querySelector("#option1").classList.add("active");



